import { motion } from "framer-motion";

const STEPS = [
  { n: "01", title: "Fill The Form", body: "Pop in your details and tell us what needs doing — takes under a minute." },
  { n: "02", title: "Tell Us More", body: "Describe the job in the form. We'll reply with a clear price — there's a minimum charge of £60 per job." },
  { n: "03", title: "Book It In", body: "Share your details and preferred date. Your request lands with us straight away." },
  { n: "04", title: "Fix N Sorted", body: "We turn up on time, do the job right, and leave the place tidy. Simple as that." },
];

const item = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] } }),
};

export const Manifesto = () => {
  return (
    <section id="process" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-14">
        <div>
          <div className="font-mono-accent text-xs tracking-widest uppercase text-[#2563EB] mb-3">/ How It Works</div>
          <h2 className="font-display font-black text-[#0A1A4A] text-4xl sm:text-6xl tracking-tight leading-[0.95]">
            FOUR STEPS.<br />ZERO HASSLE.
          </h2>
        </div>
        <p className="max-w-sm text-[#0A1A4A]/70 text-base">No quotes to chase, no waiting around. Transparent pricing from the first click to the finished job.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 border-2 border-[#0A1A4A]">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            custom={i}
            variants={item}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className={`group p-8 lg:p-10 border-[#0A1A4A] ${i < STEPS.length - 1 ? "border-b-2 sm:border-b-0 lg:border-r-2" : ""} ${i % 2 === 0 ? "sm:border-r-2 lg:border-r-2" : ""} ${i < 2 ? "sm:border-b-2 lg:border-b-0" : ""} hover:bg-[#0A1A4A] transition-colors`}
            data-testid={`step-${s.n}`}
          >
            <div className="font-mono-accent font-bold text-5xl text-[#2563EB] mb-6 group-hover:text-[#EAB308] transition-colors">{s.n}</div>
            <h3 className="font-display font-extrabold text-xl uppercase text-[#0A1A4A] mb-3 group-hover:text-white transition-colors">{s.title}</h3>
            <p className="text-sm text-[#0A1A4A]/70 leading-relaxed group-hover:text-white/70 transition-colors">{s.body}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
